module.exports = __webpack_public_path__ + "static/assets/7382ef4a40ab40e4fec38b912a5c9ad7.png";